import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters({
      hasCurrency: 'store/hasCurrency',
      currency: 'store/currency',
    }),

    currencyPrefix() {
      if (!this.hasCurrency) {
        return ''
      }

      return this.currency.prefix
    },

    currencySuffix() {
      if (!this.hasCurrency) {
        return ''
      }

      return this.currency.suffix
    },
  },
}
